//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from "@/request/index";
import { getUrlparams } from "@/utils/util.js";
import footerNav from "@/components/footerNav";
import headDetails from "@/components/headDetails";
import { uploadFile } from "@/utils/auth";
import { Dialog, Toast } from "vant";
import homeTip from "@/components/homeTip";

export default {
  name: "procurementClearance",
  components: {
    footerNav,
    homeTip,
    headDetails
  },
  data() {
    return {
      show: false,
      throughImg: false,
      rejectedImg: false,
      rejectedLoading: false,
      throughLoading: false,
      rejected: true,
      through: true,
      purchaseOrderId: "",
      basicForm: {
        crtTime: "",
        recTime: "",
        crtUser: "",
        recUser: "",
        purchaseOrderId: "",
        purchaseOrderSn: "",
        planOrderSn: "",
        planOrderId: "",
        firstDeptId: "",
        secondDeptId: "",
        firstDeptName: "",
        procurementList: [],
        secondDeptName: "",
        taxRate: "",
        supplierId: "",
        supplierCode: "",
        storeId: "",
        storeCode: "",
        purchaseStatus: "",
        supervisorUserId: "",
        supervisorUserName: "",
        paymentType: "",
        remark: "",
        billDate: "",
        secondPaymentTypeName: "",
        bidFeeUndertakeText: "",
        materialFeeUndertakeText: "",
        materielName:"",
        dayNum:""
      },
      canSubmit: true,
      rejectRemark: ""
    };
  },
  created() {
    if (this.$route.query.purchaseOrderId) {
      this.purchaseOrderId = this.$route.query.purchaseOrderId;
    }
    this.queryData();
  },
  mounted() {
    if(this.$route.query.type == "view"){
      this.rejected = false
      this.through = false
    }
  },
  methods: {
    down(){this.rejectedLoading = false;},
    throughClick() {
      this.throughLoading = true;
      axiosApi
        .queryPurchaseOrderAudit({
          purchaseOrderIdList: [this.purchaseOrderId],
          purchaseStatus: 1
        })
        .then(response => {
          this.throughImg = true;
          this.through = false;
          this.throughLoading = false;
          this.rejected = false;
        })
        .catch(error => {
          this.throughLoading = false;
        });
    },
    rejectedClick() {
      this.rejectedLoading = true;
      this.show = true;
    },
    onSubmit(values) {
      this.show = false;
      axiosApi
        .queryPurchaseOrderAudit({
          purchaseOrderIdList: [this.purchaseOrderId],
          purchaseStatus: 12,
          rejectRemark: this.rejectRemark
        })
        .then(response => {
          this.rejectedImg = true;
          this.through = false;
          this.rejected = false;
        })
        .catch(error => {});
        this.rejectedLoading = false;
    },
    queryData() {
      var queryParams = {
        purchaseOrderId: this.purchaseOrderId
      };
      axiosApi
        .queryPurchaseOrder(queryParams)
        .then(response => {
          if(response.content.purchaseStatus !=11 ){
            this.rejected = false
            this.through = false
          }
          // 承担方
          if (response.content.bidFeeUndertake == 0) {
            response.content.bidFeeUndertakeText = "供应商承担";
          } else if (response.content.bidFeeUndertake == 1) {
            response.content.bidFeeUndertakeText = "采购方承担";
          }
          if (response.content.materialFeeUndertake == 0) {
            response.content.materialFeeUndertakeText = "供应商承担";
          } else if (response.content.materialFeeUndertake == 1) {
            response.content.materialFeeUndertakeText = "采购方承担";
          }
          // 税率
          response.content.taxRate = response.content.taxRate + "%";
          var data = response.content;
          for (var ind in data) {
            var val = data[ind] != null ? data[ind] : "";
            this.$set(this.basicForm, ind, val);
          }
          var channelStr = "";
          if (this.basicForm.firstDeptName) {
            channelStr += this.basicForm.firstDeptName;
          }
          if (this.basicForm.secondDeptName) {
            channelStr += "/" + this.basicForm.secondDeptName;
          }
          this.$set(this.basicForm, "channelStr", channelStr);
          queryParams = {
            purchaseOrderId: this.purchaseOrderId,
            spuCodeList: [],
            skuCodeList: [],
            colorValueList: []
          };
          // 列表查询
          axiosApi
            .queryPurchaseContract(queryParams)
            .then(response => {
              response.content.purchaseOrderGoodsDeliveryList.forEach(item => {
                if (item.deliveryTimeText == "") {
                  item.deliveryTimeText = "无";
                }
                this.basicForm.procurementList.push({
                  spuCode: item.spuCode,
                  deptName: item.deptName,
                  colorValue: item.colorValue,
                  allSizeValue: item.allSizeValue,
                  orderNum: item.orderNum,
                  unitPrice: item.unitPrice,
                  totalContractPrice: item.totalContractPrice,
                  deliveryTimeText: item.deliveryTimeText,
                  materielName:item.materielName,
                  dayNum:item.dayNum
                });
              });
            })
            .catch(error => {});
        })
        .catch(error => {});
    }
    // onSubmit(type) {
    //   // queryPurchaseOrderAudit
    //   console.log(type);
    //   if (this.canSubmit && this.pageType == 1) {
    //     var params = {
    //       sendOrderStatus: 2,
    //       purchaseOrderId: this.purchaseOrderId,
    //       orderPosition: this.basicForm.orderPosition,
    //       confirmFile: this.basicForm.confirmFile,
    //       reciveTotalCtn: this.basicForm.reciveTotalCtn
    //     };
    //     axiosApi
    //       .receiveSendOrder(params)
    //       .then(response => {
    //         Toast.success("操作成功");
    //         this.$router.back(-1);
    //       })
    //       .catch(error => {});
    //   }
    //   if (this.pageType != 1) {
    //     Toast.success("保存成功");
    //     this.$router.back(-1);
    //   }
    // }
  }
};



// WEBPACK FOOTER //
// ./src/pages/sendOrder/procurementClearance.vue